// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1n-2";
export var blackBorderOnHover = "_1n-7";
export var cell = "_1n-6";
export var cellContainer = "_1n-3";
export var checked = "_1n-8";
export var disabled = "_1n-5";
export var featuredIconCellContainer = "_1n-9";
export var featuredIconTextContainer = "_1n-b";
export var featuredIconWrapper = "_1n-a";
export var noBorder = "_1n-c";
export var orangeSelectedRow = "_3z-3";
export var overflowableText = "_1n-0";
export var overflowableTextContainer = "_1n-1";
export var row = "_1m-0";
export var rowCheckboxCell = "_1n-4";
export var selectableTable = "_3z-2";